<vdr-card
  style="grid-column: 1 / -1; margin-bottom: 1rem"
  [title]="'product-bundles.widgetTitle' | translate"
>
  <span>
    {{ 'product-bundles.widgetInfo' | translate }}
  </span>
  <div style="padding: 1rem 0 0;">
    <vdr-form-field [label]="'product-bundles.addItem' | translate" style="width: 100%">
      <vdr-product-variant-selector
        aria-multiline="true"
        (productSelected)="onVariantSelected($event)"
        class="mb-4"
        style="width: 100%"
      >
      </vdr-product-variant-selector>
    </vdr-form-field>
  </div>

  <div
    *ngFor="let item of selectedVariants; let i = index"
    style="
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      background: #f9f9f9;
      padding: 1rem;
      border-radius: 6px;
      margin-top: 1rem;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    "
  >
    <div style="flex: 1">
      <div style="font-weight: 600; margin-bottom: 0.5rem">
        <a
          [routerLink]="['/catalog', 'inventory', item.productId, 'variants', item.id]"
          style="text-decoration: none; color: inherit"
          >{{ item.name }} ({{ item.sku }})</a
        >
      </div>
      <div style="display: flex; gap: 1rem; flex-wrap: wrap;">
        <vdr-form-field [label]="'product-bundles.priceLabel' | translate" style="max-width: 200px">
          <vdr-currency-input 
            name="price-{{i}}" 
            [currencyCode]="currencyCode" 
            [(ngModel)]="item.price" />
        </vdr-form-field>
        <vdr-form-field [label]="'product-bundles.quantityLabel' | translate" style="max-width: 80px">
          <input
            type="number"
            name="quantity-{{i}}"
            class="form-control"
            [(ngModel)]="item.quantity"
            min="1"
            step="1"
            style="width: 100%"
          />
        </vdr-form-field>
      </div>
    </div>

    <button
      type="button"
      class="btn btn-outline btn-sm"
      (click)="removeVariant(item)"
      style="margin-left: 1rem"
    >
      {{ 'product-bundles.removeItem' | translate }}
    </button>
  </div>

  <div *ngIf="selectedVariants.length > 0" style="margin-top: 2rem;">
    <vdr-form-field [label]="'product-bundles.bundleListPriceLabel' | translate" style="max-width: 400px; margin-bottom: 1rem;">
      <vdr-currency-input
        [formControl]="bundleListPriceControl"
        [currencyCode]="currencyCode"
      ></vdr-currency-input>
    </vdr-form-field>
    <div style="text-align: right">
      <button type="button" class="btn btn-primary" (click)="saveBundle()">
        {{ 'product-bundles.save' | translate }}
      </button>
    </div>
  </div>
</vdr-card>
